module.exports = __webpack_public_path__ + "static/media/icon-hybrid.64e6e58c.png";